'use strict'
import _ from 'lodash'
import moment from 'moment'

const numDecimali = 4

function arrotonda(valore) {
  const fattore = Math.pow(10, numDecimali)
  return Math.round((valore + Number.EPSILON) * fattore) / fattore
}

function getPrezzoUnita(item, unita) {
  // ritorna il prezzo in base all'unità di misura selezionata
  // TODO: Gestire nel prodotto un array di valori con i corrispondenti fattori di conversione
  // Per adesso considero solo 2 prezzi (confezione/chilo e pezzo)
  const prezzoPezzo = _ .get(item, 'appoggio.prodotto.item.magazzino.prezzoAcquistoPezzo', 0)
  const prezzo = _.get(item, 'appoggio.prodotto.acquisto', 0)
  if (['pz', 'n'].includes(unita)) {
    return prezzoPezzo
  } else {
    return prezzo
  }
}

function calcolaTotaliAliquote_v2(totali, valori, spese, scontoInFattura, totaleMerce) {
  const sconto = parseFloat(scontoInFattura || 0)
  const totImpo =  _.sumBy(valori, (el) => { return (el.importoNettoTotale || 0) + (el.acquisto || 0) })
  const speseNd = spese.filter(x => !x.documentate)
  const speseD = spese.filter(x => x.documentate)
  const totSpeseNd = _.sumBy(speseNd, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const totSpeseD = _.sumBy(speseD, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const cr = totSpeseNd / totaleMerce
  // Lo sconto agisce sull'imponibile, ma devo ripartirlo in percentuale perchè le varie voci sono separate per aliquota 
  const scontoPerc = (totImpo - (totImpo - sconto)) / totImpo

  totali['generale'] = totali['generale'] || {}
  for (let v of valori) {
    totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {}
    let t = totali[`iva_${v.aliquota}`]
    let importoNetto =  +(((v.importoNettoTotale || 0) + (v.acquisto || 0)) * (1 - scontoPerc)).toFixed(numDecimali)
    let acquisto =  +((v.acquisto || 0) * (1 - scontoPerc)).toFixed(numDecimali)
    let importoOmaggi =  +((v.omaggi || 0) * (1 - scontoPerc)).toFixed(numDecimali)
    t.merce = +((t.merce || 0) + importoNetto).toFixed(numDecimali)
    let speseAl = +(importoNetto * cr).toFixed(numDecimali)
    t.spese = +((t.spese || 0) + speseAl).toFixed(numDecimali)
    t.imponibile = +((t.imponibile || 0) + importoNetto + speseAl).toFixed(numDecimali)
    // t.iva = +((t.iva || 0) + v.iva).toFixed(numDecimali)
    // let iva = +(v.aliquota * (importoNetto + speseAl + importoOmaggi) / 100).toFixed(numDecimali)
    let iva = v.iva
    t.ivaCodice = v.codice
    t.iva = +((t.iva || 0) + iva).toFixed(numDecimali)

    t.ivaOmaggi = +((t.ivaOmaggi || 0) + arrotonda((v.aliquota / 10) * ((importoOmaggi) / 100))).toFixed(numDecimali)
    t.importoOmaggi = +importoOmaggi.toFixed(numDecimali) 

    t.importo = +((t.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    t.aliquota = String(v.aliquota) // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita

    let tg = totali['generale']
    tg.imponibile = +((tg.imponibile || 0) + (importoNetto + speseAl)).toFixed(numDecimali)

    tg.nettoMerce = +((tg.nettoMerce || 0) + importoNetto).toFixed(numDecimali)
    tg.totaleMerce = +((tg.totaleMerce || 0) + (v.importoNettoTotale || 0) + (v.acquisto || 0)).toFixed(numDecimali)
    tg.spese = +((tg.spese || 0) + speseAl).toFixed(numDecimali)
    tg.iva = +((tg.iva || 0) + iva).toFixed(numDecimali)
    tg.importo = +((tg.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    tg.acquisto = +((tg.acquisto || 0) + acquisto).toFixed(numDecimali)
    tg.quantita = (tg.quantita || 0) + v.quantita
  }


  if (totSpeseD > 0) {
    totali[`iva_N1`] = totali[`iva_N1`] || {}
    let t = totali[`iva_N1`]
    t.imponibile = +((t.imponibile || 0) + totSpeseD).toFixed(numDecimali)
    t.iva = 0
    t.ivaOmaggi = 0
    t.importo = t.imponibile
    t.ivaCodice = 'N1'
    t.aliquota = 0
    t.quantita = 1
    t.spese = +((t.spese || 0) + totSpeseD).toFixed(numDecimali)
    t.merce = t.merce || 0
    totali.generale.spese = +(totali.generale.spese + t.spese).toFixed(numDecimali)
  }

  totali.generale.importo = +((_.get(totali, 'generale.importo', 0) || 0) + totSpeseD).toFixed(numDecimali)
  totali.generale.speseDocumentate = +(totSpeseD).toFixed(numDecimali)

  //TODO: Verificare. Inserisco calcolo seguente per problemi di arrotondamento ricalcolo iva e totale da imponibile per ogni aliquota
  // Può essere evitato se si sommano i totali delle ddt
  // Tiene conto anche degli omaggi con rivalsa

  let totaleIva = 0
  let totaleImporto = 0

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.iva = +(al.imponibile * parseFloat(al.aliquota) / 100).toFixed(numDecimali)
    totaleIva += (al.iva + al.ivaOmaggi)
    al.importo = +(al.imponibile + al.iva + al.ivaOmaggi).toFixed(numDecimali)
    totaleImporto += al.importo
  }
  totali.generale.iva = totaleIva
  totali.generale.importo = +totaleImporto.toFixed(numDecimali)

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.imponibile = +al.imponibile.toFixed(2)
    al.importo = +al.importo.toFixed(2)
    al.iva = +al.iva.toFixed(2)
    al.merce = +al.merce.toFixed(2)
  }
  totali.generale.imponibile = +totali.generale.imponibile.toFixed(2)
  totali.generale.importo = +totali.generale.importo.toFixed(2)
  totali.generale.iva = +totali.generale.iva.toFixed(2)
  totali.generale.nettoMerce = +totali.generale.nettoMerce.toFixed(2)
  totali.generale.totaleMerce = +totali.generale.totaleMerce.toFixed(2)


  return totali
}

function calcolaTotaliAliquoteSpese(totaliFattura, speseFattura, scontoInFattura) {
  // Verificare se agistono sul totale imponibile o vanno ripartite per aliquota
/*   const totaleImponibile = totaliFattura.generale.imponibile
  let tg = {}
  const totali = _.omit(totaliFattura, 'generale')   
  const totaliAliquota = Object.values(totali)
  for (let t of totaliAliquota) {
    const { totaleSpese } = calcolaSpese(speseFattura, t.imponibile, totaleImponibile)
    t.imponibile += totaleSpese
    t.spese = totaleSpese
    // const calcIva = (t.aliquota !== 0) ? (t.imponibile * (parseFloat(t.aliquota) / 100)) : 0
    t.iva = +((t.aliquota !== 0) ? (t.imponibile * (parseFloat(t.aliquota) / 100)) : 0).toFixed(2)
    t.importo = +(t.imponibile + t.iva).toFixed(2)

    tg.imponibile = +((tg.imponibile || 0) + t.imponibile).toFixed(2) 
    tg.iva = +((tg.iva || 0) + t.iva).toFixed(2)
    tg.importo = +((tg.importo || 0) + t.importo).toFixed(2)
    tg.quantita = (tg.quantita || 0) + t.quantita
    tg.spese = (tg.spese || 0) + t.spese
  }
  const totaleCompleto = { ...totali, generale: tg } */
  const totaleCompleto = totaliFattura
  return totaleCompleto
}

function calcolaScadenze(totali, pagamento) {
  const scadenze = []
  var scadenza
  if (!pagamento) {
    scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
    scadenze.push(scadenza)
  } else {
    if (!pagamento.giorniPagamento) {
      if (!pagamento.dataPagamento || pagamento.dataPagamento === 'DF') {
        scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
      } else {
        scadenza = { data: moment().endOf('mounth').format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
      }
      scadenze.push(scadenza)
    } else {
      let numeroPagamenti = pagamento.giorniPagamento.length
      let importoScadenza = +(totali.generale.importo / numeroPagamenti).toFixed(numDecimali)
      let acc = 0
      for (let i = 0; i < numeroPagamenti; i++) {
        if (i === numeroPagamenti - 1) {
          importoScadenza = +(totali.generale.importo - acc).toFixed(numDecimali)
        }
        acc += importoScadenza
        let dataScadenza = pagamento.dataPagamento === 'DF' ? moment().add(pagamento.giorniPagamento[i], 'day') : moment().add(pagamento.giorniPagamento[i], 'day').endOf('month')
        scadenza = { data: dataScadenza.format('DD/MM/YYYY'), importo: +importoScadenza.toFixed(2) }
        scadenze.push(scadenza)
      }
    }
  }
  return scadenze
}

function calcolaSpese(speseFattura, importo, totale) {
  const spese = []
  var valore
  var totaleSpese = 0
  for (let sp of speseFattura) {
    if (!sp.tipo || sp.tipo === 'IMPORTO') {
      valore = +parseFloat(sp.valore || 0).toFixed(numDecimali)
    }
    if (sp.tipo === 'PERCENTUALE') {
      valore = +(parseFloat(sp.valore || 0) * importo / 100).toFixed(numDecimali)
    }
    // totaleSpese += +(valore * importo / totale).toFixed(numDecimali)   ?????
    totaleSpese += valore
    spese.push({ codice: sp.codice, descrizione: sp.descrizione, valore: valore, documentate: sp.documentate })
  }
  return { spese, totaleSpese: +totaleSpese.toFixed(numDecimali) }
}

function calcolaValoriDocumento(ddt, repartiStatistica) {
  const rr = ddt.righe.filter(x => x.aliquotaIva)
  let aliquote = rr.map(x => _.omit(x.aliquotaIva, 'stampante'))
  const isOrdine = ['ordineFornitore'].includes(ddt.tipoDocumento.tipoDocumento)

  // let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))
  aliquote = _.uniqBy(aliquote, 'codice')
  const valori = []
  //for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
  for (let al of aliquote.filter(x => !_.isEmpty(x))) { // aliquote
    al.aliquota = al.valore
    const qta = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => {
      let qta = parseFloat(el.quantita) || parseFloat(el.quantita2)
      qta += isOrdine ? parseFloat(_.get(el, 'ordine.ordinato', 0) || 0) : 0
      return qta
    })
    const vl = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale || 0) })
    const consegnato = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(_.get(el, 'ordine.consegnato',0)) })
    let valore = {
      quantita: qta + (isOrdine ? 0 : consegnato)
    }
    valore.prezzoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoUnitario || 0) })
    valore.prezzoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale || 0) })
    // valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
    
    valore.prezzoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario || 0) })
    valore.prezzoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoTotale || 0) })
    // valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoUnitario || 0) })
    valore.importoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoTotale || 0) })
    // valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoUnitario || 0) })
    // valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoTotale || 0) })
    valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? 0 : parseFloat(el.valore.importoNettoTotale) })
    valore.omaggi = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? parseFloat(el.valore.importoNettoTotale) : 0 })

    // valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
    // valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(numDecimali)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale - valore.omaggi).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(numDecimali)
    if (ddt.tipoDocumento.tipoDocumento === 'ddtFornitore' || ddt.tipoDocumento.tipoDocumento === 'ordineFornitore' || ddt.tipoDocumento.causale === 'acquisto') {
      valore.prezzoUnitario = 0
      valore.prezzoTotale = 0
      valore.prezzoNettoUnitario = 0
      valore.prezzoNettoTotale = 0
      valore.importoUnitario = 0
      valore.importoTotale = 0
      valore.importoNettoUnitario = 0
      valore.importoNettoTotale = 0
    }
    valore.acquisto = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => {
      const prezzoUnita = getPrezzoUnita(el, el.unitaMisura.codice) || getPrezzoUnita(el, el.unitaMisura) || 0
      // const acquisto = +parseFloat(_.get(el, 'ordine.prezzoUnitario', 0) || _.get(el, 'appoggio.prodotto.acquisto', 0) || _.get(el, 'valore.acquisto', 0)).toFixed(numDecimali)
      let acquisto = +parseFloat( el.omaggio ? 0 : (_.get(el, 'ordine.prezzoUnitario', 0) || prezzoUnita || _.get(el, 'valore.acquisto', 0))).toFixed(numDecimali)
      if (el.valore.sconto100) {
        acquisto = 0
      }
      let qta = parseFloat(el.quantita || 0) + parseFloat(el.quantita2 || 0) // + parseFloat(_.get(el, 'ordine.ordinato', 0)) + parseFloat(_.get(el, 'ordine.consegnato', 0)) 
      qta += isOrdine ? parseFloat(_.get(el, 'ordine.ordinato', 0)) : parseFloat(_.get(el, 'ordine.consegnato', 0)) 
      return +parseFloat(qta * acquisto).toFixed(numDecimali)
    })

    valore = { ...valore, ...al }
    valori.push(valore)
  }
  return valori
}

function calcolaDettaglioDdt(ddt, repartiStatistica) {
  const valori = []

  for(let riga of ddt.righe) {
    let valore = {
      quantita: +parseFloat(riga.quantita).toFixed(2)
    }
    valore.prezzoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(2)
    
    valore.prezzoNettoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(2) //  _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(2)

    valore.importoUnitario = +parseFloat(riga.valore.importoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(2)

    valore.importoNettoUnitario = +parseFloat(riga.valore.importoNettoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(2)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(2)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(2)
    valore.sconto1 = riga.valore.sconto1
    valore.sconto2 = riga.valore.sconto2
    valore.sconto3 = riga.valore.sconto3
    valore.sconto4 = riga.valore.sconto4
    valore.item = { codice: riga.prodotto.codice, descrizione: riga.descrizione }

    const reparto = riga.repartoFiscale
    const rp = repartiStatistica.find(x => String(x.repartoFiscale) === reparto)

    valore = { ...valore, ...rp }
    valori.push(valore)
  }
  
  return valori
}

export default {
/*   getTotaleProdotti,
  getScontiScontrino,
  getTotaleResi, */
  // calcolaTotaliAliquote,
  calcolaTotaliAliquote_v2,
  calcolaTotaliAliquoteSpese,
  // calcolaValoriScontrino,
  // calcolaDettaglioScontrino,
  calcolaScadenze,
  calcolaSpese,
  calcolaValoriDocumento
  // calcolaDettaglioDdt
}
